<template>
    <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="ghost, hidden, unknown">
            <g id="vector">
                <path
                    d="M5.25 9.94444V20.2023C5.25 20.9864 6.11121 21.4655 6.77736 21.052L7.94088 20.3298C8.52258 19.9687 9.24854 19.9303 9.8651 20.228L11.6305 21.0802C12.1798 21.3454 12.8202 21.3454 13.3695 21.0802L15.1349 20.228C15.7515 19.9303 16.4774 19.9687 17.0591 20.3298L18.2226 21.052C18.8888 21.4655 19.75 20.9864 19.75 20.2023V9.94444C19.75 5.97106 16.5041 2.75 12.5 2.75C8.49594 2.75 5.25 5.97106 5.25 9.94444Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                />
                <path
                    d="M10.75 10.5C10.75 10.9142 10.4142 11.25 10 11.25C9.58579 11.25 9.25 10.9142 9.25 10.5C9.25 10.0858 9.58579 9.75 10 9.75C10.4142 9.75 10.75 10.0858 10.75 10.5Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                />
                <path
                    d="M15.75 10.5C15.75 10.9142 15.4142 11.25 15 11.25C14.5858 11.25 14.25 10.9142 14.25 10.5C14.25 10.0858 14.5858 9.75 15 9.75C15.4142 9.75 15.75 10.0858 15.75 10.5Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                />
            </g>
        </g>
    </svg>
</template>
